import React, { ReactElement, PropsWithChildren } from 'react'
import { Text, Spinner } from 'theme-ui'
import { Button, ButtonProps, Svg } from 'ui'
import ButtonArrow from 'images/button-arrow-right.svg'

interface LoginSignUpButtonProps extends Partial<ButtonProps> {
  isLoading: boolean
  disabled: boolean
  ariaLabel: string
  isSubmitButton?: boolean
}

export function LoginSignUpButton({
  isLoading,
  disabled,
  children,
  isSubmitButton = true,
  ...props
}: PropsWithChildren<LoginSignUpButtonProps>): ReactElement {
  return (
    <Button
      variant="gradientButton"
      disabled={disabled}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        width: ['100%', '100%'],
        px: ['0.4rem', '1.2rem'],
        gap: '0.8rem',
      }}
      type={isSubmitButton ? 'submit' : 'button'}
      {...props}
    >
      {isLoading ? (
        <Spinner
          color="white"
          sx={{
            height: '1.8rem',
          }}
        />
      ) : (
        <>
          <Text>{children}</Text>
          <Svg
            fill={disabled ? 'white50' : 'white'}
            svg={ButtonArrow}
            sx={{ width: '1.6rem', height: '1.6rem' }}
            descriptiveText={`${children} button arrow`}
          />
        </>
      )}
    </Button>
  )
}
